import { render } from "./BaseProduct.vue?vue&type=template&id=1950e0ef&scoped=true"
import script from "./BaseProduct.vue?vue&type=script&lang=js"
export * from "./BaseProduct.vue?vue&type=script&lang=js"

import "./BaseProduct.vue?vue&type=style&index=0&id=1950e0ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1950e0ef"]])

export default __exports__